import InfoField from '../InfoField';
import PiezasList from '../PiezasList';
import { formatPrecio } from '../../utils';

const MinimalView = ({ alternativa, piezas = [] }) => {
    const hasPiezas = piezas.length > 0;
    const hasMultiplePiezas = piezas.length > 1;

    return (
        <div className="row g-3">
            <div className="col-md-6">
                <InfoField
                    label="Nº Presupuesto alternativa"
                    value={alternativa?.numero_presupuesto ?? '-'}
                />
            </div>
            <div className="col-md-6">
                {hasPiezas ? (
                    <InfoField
                        label={
                            hasMultiplePiezas
                                ? 'Piezas alternativa'
                                : 'Pieza alternativa'
                        }
                        value={
                            <PiezasList
                                piezas={piezas}
                                variant="alternativa"
                                precioVentaTotal={
                                    alternativa?.precio_venta_nuevo
                                }
                            />
                        }
                    />
                ) : (
                    <InfoField
                        label="Precio venta nuevo"
                        value={formatPrecio(
                            alternativa?.precio_venta_nuevo,
                        )}
                    />
                )}
            </div>
        </div>
    );
};

export default MinimalView;
